import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import isNull from 'lodash.isnull';

import Answer from './Answer';

const Question = ({ id, question_text, question_type, onAnswerValueChange, conditional_parent_question_id, ...rest }) => {
	return (
		<div className={cn({ 'has-parent': !isNull(conditional_parent_question_id) })}>
			<h4>{question_text}</h4>
			<div className="form-group">
				<Answer
					{...rest}
					answerType={question_type}
					onChange={({ target }) => onAnswerValueChange(id, target.value)}
				/>
			</div>
		</div>
	);
};

Question.propTypes = {
	id: PropTypes.number,
	question_text: PropTypes.string,
	question_type: PropTypes.string,
	onAnswerValueChange: PropTypes.func,
	conditional_parent_question_id: PropTypes.number,
};

export default Question;
